import React from "react";
import { useDispatch } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import { deleteNotification, resetFilters } from "../redux/notificationsSagas";

export const Delete = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const primaryBtnHandler = () => {
    dispatch(deleteNotification());
    close();
  };

  let close = () => {
    dispatch(resetFilters());
    onClose();
  };

  return (
    <MainModal
      isOpen={isOpen}
      headerText="Delete"
      containerClassName="dialog"
      parentSelector=".notifications"
      width={400}
      height="auto"
      headerCloseHandler={close}
      primaryButtonText="Yes"
      primaryBtnHandler={() => primaryBtnHandler()}
      secondaryBtnText="No"
      secondaryBtnHandler={() => close()}
      onClose={close}
    >
      Are you sure to delete notification?
    </MainModal>
  );
};
